import { Box, MenuItem, Select, Typography, useTheme } from "@mui/material";

interface SelectInputProps {
  label?: string;
  value: string | number;
  onChange: (event: any) => void;
  options: { label: string; value: string | number }[];
}
const SelectInput = ({ label, value, onChange, options }: SelectInputProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: theme.nawy.colors.semantic.layer.primary,
      }}
    >
      {label && (
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.xs.regular,
          }}
        >
          {label}
        </Typography>
      )}
      <Select
        value={value}
        onChange={onChange}
        sx={{
          width: "100%",
          height: "36px",
        }}
        slotProps={{
          input: {
            sx: {
              ...theme.nawy.typography.english.variants.body.md.regular,
              height: "36px",
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default SelectInput;
